<template>
	<section :class="['block-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
	</section>
</template>

<script>
export default {
	props: ['data', 'visible', 'ready'],
	data() {
		return {
			defaultColorMode: 'dark',
			componentClass: 'base',
		}
	},
	computed: {
		colorMode() {
			return (typeof this.data.colorMode!=='undefined') ? this.data.colorMode : this.defaultColorMode
		}
	},
	watch: {
		visible(newVal) {
			if (newVal) {
				this.ready = true;
			}
		}
	}
}
</script>